import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress cross-origin frame errors from PostHog/analytics trying to access PayPal iframes
window.addEventListener("error", (e) => {
  if (
    e.message &&
    (e.message.includes("cross-origin frame") ||
      e.message.includes("removeEventListener") ||
      e.message.includes("SecurityError"))
  ) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return true;
  }
}, true);

window.addEventListener("unhandledrejection", (e) => {
  if (
    e.reason &&
    e.reason.toString &&
    (e.reason.toString().includes("cross-origin") ||
      e.reason.toString().includes("SecurityError"))
  ) {
    e.preventDefault();
  }
});

// Block React dev error overlay for cross-origin errors
const origOnerror = window.onerror;
window.onerror = function (msg, source, lineno, colno, error) {
  if (
    (typeof msg === "string" && (msg.includes("cross-origin") || msg.includes("removeEventListener"))) ||
    (source && source.includes("posthog"))
  ) {
    return true;
  }
  if (origOnerror) return origOnerror(msg, source, lineno, colno, error);
  return false;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
